import { FC, Fragment, useState } from 'react';
// Models
import IAnswer from 'models/Answer';
// Component
import { Button } from 'components/Buttons';
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Selectors
import { selectQuestionAnswerPicked, selectIsAnyAnswerCorrect } from 'store/player/playerSelectors';
import { setQuestionAnswerPicked, setQuestionStart } from 'store/player/playerSlice';
import { selectQuestion, selectQuiz } from 'store/quiz/quizSelectors';
import IQuiz from 'models/Quiz';
import QuizTypes from 'types/QuizTypes';

type Props = {
  answer: IAnswer;
  onClick: (answer:{ ref:string, title:string, correct:boolean }) => void;
  disabled?: boolean;
};

const AnswerButton:FC<Props> = ({
  // Props
  answer, onClick, disabled = false,
}) => {
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const question = useAppSelector(selectQuestion);
  const questionAnswerPicked:boolean = useAppSelector(selectQuestionAnswerPicked);
  const isAnyAnswerCorrect:boolean = useAppSelector(selectIsAnyAnswerCorrect);
  const quiz:IQuiz = useAppSelector(selectQuiz);

  const { highlightCorrectAnswer } = quiz.questionsSettings;

  const [ clicked, setClicked ] = useState(false);

  const handleClick = () => {
    if(clicked) return;
    const { ref, title, correct } = answer;

    dispatch(setQuestionStart(false));

    onClick({ ref, title, correct });
    dispatch(setQuestionAnswerPicked(true));

    setClicked(true);
  }

  const highlightAnswer = [QuizTypes.Scoring, QuizTypes.BeatTheExpert, QuizTypes.Streak].includes(quiz.type);
  const isPredictionQuiz = quiz.type === QuizTypes.Prediction;

  const correctColor = quiz.questionsSettings.correctAnswerColor;
  const incorrectColor = quiz.questionsSettings.incorrectAnswerColor;

  const backgroundColor = questionAnswerPicked && clicked && highlightAnswer
    ? isAnyAnswerCorrect || answer.correct
      ? correctColor
      : incorrectColor
    : highlightCorrectAnswer && !clicked && questionAnswerPicked && answer.correct && highlightAnswer
      ? correctColor
      : '';
  const textColor = backgroundColor ? 'white' : '';

  const isExpertAnswer = quiz.type === QuizTypes.BeatTheExpert && question.config?.referenceAnswer?.input?.choice?.ref === answer.ref;

  return (
    <Button
      className={`
        relative
        ${questionAnswerPicked ? 'pointer-events-none' : ''}
        ${isPredictionQuiz ? clicked ? 'selected-answer-button' : 'bg-linear' : ''}
        normal-case font-bold
        ${quiz.type === QuizTypes.BeatTheExpert ? 'px-14' : ''}
      `}
      style={{
        backgroundColor: backgroundColor ? backgroundColor : undefined,
        color: textColor ? textColor : undefined,
      }}
      onClick={handleClick}
      disabled={disabled || clicked}
    >
      <span className={disabled ? 'blur-sm  select-none' : ''}>{answer.title}</span>
      {quiz.type === QuizTypes.BeatTheExpert ? (
        <Fragment>
          {clicked ? (
            <div className="absolute top-1/2 left-[-6px] flex items-center gap-2 translate-y-[-50%]">
              <div className="w-4 h-4 border-2 border-white rounded-full" style= {{ backgroundColor: backgroundColor || 'black' }} />
              <p style={{ color: textColor || undefined }}>YOU</p>
            </div>
          ) : null}

          {questionAnswerPicked && isExpertAnswer ? (
            <div className="absolute top-1/2 right-[-6px] flex items-center gap-2 translate-y-[-50%]">
              <p style={{ color: textColor || undefined }}>EXP</p>
              <div className="w-4 h-4 border-2 border-white rounded-full" style= {{ backgroundColor: backgroundColor || 'black' }} />
            </div>
          ) : null}
        </Fragment>
      ) : null}
    </Button>
  )
}

export default AnswerButton;
